<template>
  <div class="option" :class="selected ? 'selected' : null" @click="select">
    <img v-if="option.img" class="option-image" :src="getImgUrl(option.img)" />
    <p v-if="option.text" class="option-text">{{ option.text }}</p>
  </div>
</template>

<script>
export default {
  props: ["option", "selected"],
  methods: {
    getImgUrl(img) {
      return require("../assets/images/" + img);
    },
    select() {
      this.$emit("select", this.option.value);
    },
  },
};
</script>

<style scoped>
.option {
  background-color: var(--quiz-option-color);
  color: var(--quiz-option-text-color);
  border: 0;
  border-radius: 0;
  font-weight: 700;
  padding: 10px;
  transition: 0.15s linear all;
}

.option > p {
  font-size: 14px;
}

.option:hover {
  background-color: var(--quiz-option-hover-color);
  color: var(--quiz-option-hover-text-color);
  cursor: pointer;
}

.selected {
  background-color: var(--quiz-selected-color);
  color: var(--quiz-selected-text-color);
}

.option-image {
  width: 100%;
  object-fit: contain;
}

.option-text {
  padding: 0 10px;
}
</style>
